import axios from "axios";

const api = axios.create({
   //baseURL: "http://localhost:3000",
   //baseURL: "https://backend-stnweb.netlify.app",
   baseURL:"https://backend-stnweb.vercel.app"
});

export default api;